import Title from "@/components/shared/Title";
import { useSiteData } from "@/context/SiteDataContext";
import React from "react";

const AboutSection = () => {
  const { siteData, loading } = useSiteData();
  const aboutData = siteData?.about || {};

  console.log("About Section Data:", aboutData);

  if (loading) return <p>Loading about data...</p>;

  return (
    <section className="relative flex w-full flex-col justify-between gap-0 px-4 py-20 md:gap-12 md:px-12 xl:gap-14 xl:px-16 xl:py-20">
      {/* About Content and Banner */}
      <div className="flex justify-between gap-7 space-y-8">
        {/* Content */}
        <div className="md:w-1/2">
          <Title title="Why Choose BioStat" className="mb-10 justify-self-center sm:justify-self-auto" />

          <h2 className="text-dark mb-2 text-xl font-semibold xl:mb-16 xl:text-5xl">
            {aboutData.title}
          </h2>

          <p className="text-gray text-[14px] font-medium xl:text-[28px]">
            {aboutData.subtitle}
          </p>

          <ul className="marker:text-primary mt-8 list-inside list-disc space-y-4 text-lg font-medium">
            {aboutData.points?.map((point, index) => (
              <li
                key={index}
                className="border-b-[0.5px] border-[#C3C3C3] pb-4 text-[14px] last:border-0 xl:text-[18px]"
              >
                <strong className="text-primary text-[20px]">
                  {point.name}:
                </strong>{" "}
                {point.value}
              </li>
            ))}
          </ul>
        </div>

        {/* Banner */}
        <img
          src={aboutData.banner}
          alt="About Us"
          className="hidden rounded-4xl object-cover md:block md:max-w-[332px] xl:max-w-[576px]"
        />
      </div>

      {/* Feature List */}
      <div className="grid grid-cols-2 gap-6 md:grid-cols-3 xl:grid-cols-4">
        {aboutData.advantages?.map((feature, index) => (
          <div
            key={index}
            className="group hover:ring-primary flex flex-col items-center justify-center rounded-3xl bg-[#F5F8FA] px-4 py-6 ring-2 ring-black/10 transition-all duration-300 hover:scale-105 xl:bg-transparent xl:py-12"
          >
            <feature.icon className="text-primary mb-3 text-[36px] md:text-[40px] xl:text-[48px]" />
            <p className="text-center text-sm font-medium text-black md:text-base xl:text-lg">
              {feature.value}
            </p>
          </div>
        ))}
      </div>

      {/* Mobile Banner */}
      <img
        src={aboutData.banner}
        alt="About Us"
        className="mt-6 max-w-64 place-self-center rounded-4xl object-cover md:hidden"
      />
    </section>
  );
};

export default AboutSection;
